import { isObject } from 'lodash-es';

import { hashSha256 } from '@change-corgi/core/crypto';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

type GetViewerDeviceReturn = Promise<string>;
export async function getViewerDeviceId(userAgent: UtilityContext['userAgent']): GetViewerDeviceReturn {
	const stringify = (obj: unknown) => {
		if (!isObject(obj)) return '';
		return Object.values(obj).filter(Boolean).join('|');
	};

	try {
		const ua = userAgent.getParsedUserAgent();

		const deviceData = stringify({ ...ua.getBrowser(), ...ua.getDevice(), ...ua.getEngine(), ...ua.getOS() });

		return await hashSha256(deviceData);
	} catch {
		return 'unknown';
	}
}
